import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetSites, GetSitesParams } from "./apiEcms.types";

const getSites = async (params: GetSitesParams, signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<GetSites>("/sites", {
    params,
    signal,
  });

  return data;
};

export const useGetSites = (params: GetSitesParams) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.SITES, params, currentGroup],
    queryFn: ({ signal }) => getSites(params, signal),
  });
};
